/**
 * Clerk's own components rendered on our palette. Without this they arrive in
 * Clerk's default light theme, which on a dark page reads as a third-party widget
 * bolted on rather than part of the product.
 */
export const clerkAppearance = {
  variables: {
    colorPrimary: "#c9a227",
    colorBackground: "#121722",
    colorText: "#e8ecf3",
    colorTextSecondary: "#94a0b4",
    colorInputBackground: "#0b0e14",
    colorInputText: "#e8ecf3",
    colorDanger: "#e5766b",
    colorSuccess: "#6bbf8a",
    borderRadius: "10px",
    fontFamily:
      'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  },
  elements: {
    card: { border: "1px solid #232b3a", boxShadow: "none" },
    headerTitle: { fontFamily: '"Cormorant Garamond", Georgia, serif', fontSize: "1.6rem" },
    formButtonPrimary: { color: "#17140a", fontWeight: 600, textTransform: "none" as const },
    footerActionLink: { color: "#c9a227" },
  },
};
